import { useState } from 'react';
import { api } from '../api';
import { Mark } from '../App';

/**
 * Sign in / create account.
 *
 * Password-based today. Auth0 on the activated-human tenant is coming, and
 * this screen is the only thing that changes: the API client, every other
 * view, and the session handling all stay as they are, because everything
 * downstream only knows about a bearer token.
 */
export default function SignIn({ onAuthenticated }) {
  const [mode, setMode] = useState('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const creating = mode === 'create';

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const auth = creating
        ? await api.signup(email, password, name || null)
        : await api.login(email, password);
      onAuthenticated(auth);
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="stack" style={{ width: '100%', maxWidth: 420 }}>
        <div className="stack" style={{ gap: 'var(--s2)', textAlign: 'center' }}>
          <div className="row" style={{ justifyContent: 'center' }}>
            <Mark size={44} />
          </div>
          <h1 style={{ fontSize: '2rem' }}>AeroGreen</h1>
          <p className="muted" style={{ margin: 0 }}>
            {creating
              ? 'Start your garden.'
              : 'Your garden is waiting.'}
          </p>
        </div>

        <form className="card auth-card stack" onSubmit={submit}>
          {creating && (
            <div>
              <label htmlFor="name">Your name</label>
              <input id="name" value={name} onChange={(e) => setName(e.target.value)}
                     placeholder="Optional" autoComplete="name" />
            </div>
          )}

          <div>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" required value={email}
                   onChange={(e) => setEmail(e.target.value)}
                   autoComplete="email" placeholder="you@example.com" />
          </div>

          <div>
            <label htmlFor="password">Password</label>
            <input id="password" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)}
                   autoComplete={creating ? 'new-password' : 'current-password'}
                   minLength={creating ? 10 : undefined}
                   placeholder={creating ? 'At least 10 characters' : ''} />
          </div>

          {error && <div className="notice notice-error">{error}</div>}

          <button className="btn btn-primary" type="submit" disabled={busy}>
            {busy ? 'One moment…' : creating ? 'Create account' : 'Sign in'}
          </button>

          <button type="button" className="btn btn-quiet btn-sm"
                  onClick={() => { setMode(creating ? 'signin' : 'create'); setError(null); }}>
            {creating ? 'I already have an account' : 'Create an account'}
          </button>
        </form>
      </div>
    </div>
  );
}
